/**
 * Client-side filter for short, already-loaded lists (e.g. a location's providers
 * in its detail sheet). Case-insensitive; every whitespace-separated term in the
 * query must appear somewhere in the item's fields, so "frasier internal" matches
 * a provider named Frasier whose specialty is Internal Medicine. A blank query
 * returns the list unchanged.
 */
export function filterByQuery<T>(
  items: readonly T[],
  query: string,
  fields: (item: T) => ReadonlyArray<string | null | undefined>
): T[] {
  const terms = query.trim().toLowerCase().split(/\s+/).filter(Boolean);
  if (terms.length === 0) return [...items];

  return items.filter((item) => {
    const haystack = fields(item)
      .filter((v): v is string => Boolean(v))
      .join(' ')
      .toLowerCase();
    return terms.every((term) => haystack.includes(term));
  });
}
